// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-request-cancel .modal-main {
  padding: 39px 26px;
}
.product-request-cancel .modal-header {
  margin-bottom: 0;
}
.product-request-cancel .modal-close-btn {
  width: 18px;
  height: 18px;
}
.product-request-cancel .modal-heading-main {
  color: #333;
  text-align: center;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.18px;
  padding-bottom: 24px;
}
.product-request-cancel .submit-btn-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 24px;
  gap: 20px;
}
.product-request-cancel .modal-description {
  color: #4C5258;
  text-align: center;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  max-width: 318px;
  width: 100%;
  margin: auto;
}
.product-request-cancel .btn-yes {
  color: #FFF;
  text-align: center;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  line-height: 12px;
  border-radius: 60px;
  background: #6ECB44;
  padding-block: 14px;
  width: 94px;
}
.product-request-cancel .btn-cancel {
  border-radius: 60px;
  border: 1px solid #6ECB44;
  color: #6ECB44;
  text-align: center;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  line-height: 12px;
  padding-block: 14px;
  width: 94px;
}

@media screen and (max-width: 492px) {
  .product-request-cancel .modal-main {
    padding: 29px 16px;
    max-width: 330px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/products/product-cancel-request/product-cancel-request.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAEI;EACI,gBAAA;AAAR;AAEI;EACI,WAAA;EACA,YAAA;AAAR;AAEI;EACI,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;AAAR;AAEI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;AAAR;AAEI;EACI,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAAR;AAGI;EACQ,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EAEA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAFZ;AAII;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAFR;;AAOA;EAEQ;IACI,kBAAA;IACA,gBAAA;EALV;AACF","sourcesContent":[".product-request-cancel{\n    .modal-main{\n        padding: 39px 26px;\n    }\n    .modal-header{\n        margin-bottom: 0;\n    }\n    .modal-close-btn{\n        width: 18px;\n        height: 18px;\n    }\n    .modal-heading-main {\n        color: #333;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px;\n        letter-spacing: 0.18px;\n        padding-bottom: 24px;\n    }\n    .submit-btn-wrap {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding-top: 24px;\n        gap: 20px;\n    }\n    .modal-description {\n        color: #4C5258;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 24px;\n        max-width: 318px;\n        width: 100%;\n        margin: auto;\n\n    }\n    .btn-yes {\n            color: #FFF;\n            text-align: center;\n            font-family:  var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            \n            line-height: 12px;\n            border-radius: 60px;\n            background: #6ECB44;\n            padding-block: 14px;\n            width: 94px;\n    }\n    .btn-cancel{\n        border-radius: 60px;\n        border: 1px solid #6ECB44;\n        color: #6ECB44;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 12px;\n        font-style: normal;\n        line-height: 12px;\n        padding-block: 14px;\n        width: 94px;\n    } \n\n}\n\n@media screen and (max-width: 492px) {\n    .product-request-cancel{\n        .modal-main{\n            padding: 29px 16px;\n            max-width: 330px;\n        }\n        \n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
